import { useEffect } from 'react';

/** Full-page redirect to an absolute URL; renders nothing. */
export default function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}
